import { SxProps } from "@mui/material";
import { UIObjectList } from "../BuildlingBlocks/UIObjectList";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { ObserveState } from "../StateManagement/ObserveState";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface IPropertyEditorObjectList<T extends object> {
    editObject: object;
    propertyName: string;
    label?: string;
    hint?: string;
    renderItemUI: (item: T) => JSX.Element;
    getItemName: (item: T, allItems: T[]) => string;
    createNewItem: () => T;
    onChange?: (items: T[]) => void;
    noDataLabel?: string;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export function PropertyEditorObjectList<T extends object>(props: IPropertyEditorObjectList<T>) {
    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );

                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <UIObjectList
                            sx={props.sx}
                            label={props.label}
                            hint={props.hint}
                            error={validationIssues?.message}
                            onChange={(v) => {
                                Reflect.set(props.editObject, props.propertyName, v);
                                StateManager.propertyChanged(props.editObject, props.propertyName);
                                if (props.onChange) props.onChange(v);
                            }}
                            values={(Reflect.get(props.editObject, props.propertyName) as T[]) || []}
                            renderItemUI={props.renderItemUI}
                            getItemName={props.getItemName}
                            noDataLabel={props.noDataLabel}
                            createNewItem={props.createNewItem}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
}
